import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteKollerhube() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-kollerhube-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-kollerhube-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="kollerhube" />
      </div>
    </div>
  );
}

export default BodenfeuchteKollerhube;
